export const GET_FRAME_SIZE = 'frameSize/GET_FRAME_SIZE';
export const GET_FRAME_SIZE_SUCCESS = 'frameSize/GET_FRAME_SIZE_SUCCESS';
export const GET_FRAME_SIZE_FAIL = 'frameSize/GET_FRAME_SIZE_FAIL';
export const STORE_FRAME_SIZE = 'frameSize/STORE_FRAME_SIZE';
export const STORE_FRAME_SIZE_SUCCESS = 'frameSize/STORE_FRAME_SIZE_SUCCESS';
export const STORE_FRAME_SIZE_FAIL = 'frameSize/STORE_FRAME_SIZE_FAIL';
